import { CallHistory } from 'one-state-call-history';
/**
 * Represents CallHistory Model Attribute
 */
export interface CallHistoryModel {
    callHistoryData?: Array<CallHistory>;
    status?: number;  // api callback status
};

export interface PeriodModel {
  startDate?: string;
  endDate?: string;
};

export enum CallType {
    ALL = "all",
    INBOUND = "inbound",
    OUTBOUND = "outbound"
};

export const historyColumns = [
    {
      title: "Time",
      key: "timestamp",
      dataIndex: "timestamp"
    },
    {
      title: "Customer Name",
      key: "customerName",
      dataIndex: "customerName"
    },
    {
      title: "ANI",
      key: "ani",
      dataIndex: "ani"
    },
    {
      title: "DNIS",
      key: "dnis",
      dataIndex: "dnis"
    },
    {
      title: "Call Time",
      key: "callTime",
      dataIndex: "callTime"
    },
    {
      title: "Hold Time",
      key: "holdTime",
      dataIndex: "holdTime"
    },
    {
      title: "Disposition",
      key: "disposition",
      dataIndex: "disposition"
    },
    {
      title: "Calls",
      key: "calls",
      dataIndex: "calls"
    },
    {
      title: "Call Type",
      key: "callType",
      dataIndex: "callType"
    },
    {
      title: "Notes",
      key: "notes",
      dataIndex: "notes",
    }
];